// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__WD1ZY","checkboxCol":"Table_checkboxCol__1LfzB","emailCol":"Table_emailCol__3DKUd","actionCol":"Table_actionCol__1NkPp"};